import { css } from '@linaria/core';

export const Root = {
  base: css`
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		z-index: 10000;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: rgba(0, 0, 0, 0.9);
		backdrop-filter: blur(4px);
	`,
};

export const Content = {
  base: css`
		position: relative;
		height: 100%;
		width: 100%;
		box-sizing: border-box;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 64px 20px 20px;
	`,
};

export const CloseButtonWrapper = {
  base: css`
		position: absolute;
		right: 20px;
		top: 20px;
		z-index: 200;

		button {
			background-color: rgba(255, 255, 255, 0.1);
			border: 1px solid rgba(255, 255, 255, 0.2);

			svg {
				fill: white;
			}

			&:hover {
				background-color: rgba(255, 255, 255, 0.2);
			}
		}
	`,
};

export const ImageContainer = {
  base: css`
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 80vw;
		max-width: 100%;
		max-height: 100%;

		.image-description {
			color: white;
			margin-top: 16px;
			text-align: center;
			font-size: 1em;
			line-height: 1.5;
			max-width: 600px;
		}
	`,
};
